// activityNewUser8
export default {
  routerTitle: '盈寶新人嚟攞獎',
  shareTitle: '迎新盛惠 盈寶新人獎金直衝6000+HKD',
  shareDesc: '財富升級！千元禮包等你拿！',

  cardOneLabel1: '首入金達標≥HK$1000',
  cardOneValue11: '內地客戶送30天港股LV2行情',
  cardOneValue12: '完成美股非專業投資者問卷送30天美股LV1行情',
  cardOneDesc1: '註：香港及海外地區送30天港股LV1行情，30天美股LV1行情',
  cardOneLabel2: '首入金第1個月內完成1筆交易，且資產≥HK$ 1000',
  cardOneValue21: '內地客戶送30天港股LV2行情',
  cardOneValue22: '完成美股非專業投資者問卷送30天美股LV1行情',
  cardOneDesc2: '註：香港及海外地區送30天港股LV1行情，30天美股LV1行情',

  cardOneLabel3: '首入金第2個月內完成3筆交易，且資產≥HK$ 1000',
  cardOneValue31: '內地客戶送30天港股LV2行情',
  cardOneValue32: '完成美股非專業投資者問卷送30天美股LV1行情',
  cardOneDesc3: '註：香港及海外地區送30天港股LV1行情，送30天美股LV1行情',

  cardTwoTitle: '首次入金2萬 (或等值) 以上',
  cardTwoSubTitle: '首次入金 HK$ 20,000 - 299,999(或等值)',
  cardTwoDesc: '滿足條件一次性發放8張100待生效代金券',
  // --
  cardTwoTable1Label1: '30天內無出金紀錄；',
  cardTwoTable1Label2: '且30天內成交股票≥1次',
  cardTwoTable1Desc1: '符合條件後，4張代金券生效可使用；',
  cardTwoTable1Desc2: '生效後60天內有效。',
  // --
  cardTwoTable2Label1: '60天內無出金紀錄；',
  cardTwoTable2Label2: '且30天內成交股票≥1次',
  cardTwoTable2Desc1: '符合條件後，2張代金券生效可使用；',
  cardTwoTable2Desc2: '生效後60天內有效。',
  // --
  cardTwoTable3Label1: '90天內無出金紀錄；',
  cardTwoTable3Label2: '且30天內成交股票≥1次',
  cardTwoTable3Desc1: '符合條件後，2張代金券生效可使用；',
  cardTwoTable3Desc2: '生效後60天內有效。',
  cardTwoTips: '特別說明：成交股票指成交港股或美股，不包含申購貨幣基金、新股、日內融及投資組合產品。',

  cardThreeTitle: '首次入金30萬 (或等值) 以上',
  cardThreeSubTitle: '首次入金 HK$ 300,000 (或等值)',
  cardThreeDesc: '滿足首次入金條件一次性發放8張100待生效代金券',
  // --
  cardThreeTable1Label1: '30天內無出金紀錄；',
  cardThreeTable1Label2: '且30天內成交股票≥1次',
  cardThreeTable1Desc1: '符合條件後，8張代金券生效可使用；',
  cardThreeTable1Desc2: '生效後60天內有效。',
  // --
  cardThreeTable2Label1: '30天內無出金紀錄；',
  cardThreeTable2Label2: '且交易額達<span>100萬</span><i>(或等值)</i>',
  cardThreeTable2Desc1: '滿足交易額條件後，發放7張代金券，即時生效可使用；',
  cardThreeTable2Desc2: '生效後60天內有效。',
  // --
  cardThreeTable3Label1: '60天內無出金紀錄；',
  cardThreeTable3Label2: '且交易額達<span>200萬</span><i>(或等值)</i>',
  cardThreeTable3Desc1: '滿足交易額條件後，發放7張代金券，即時生效可使用；',
  cardThreeTable3Desc2: '生效後60天內有效。',
  // --
  cardThreeTable4Label1: '90天內無出金紀錄；',
  cardThreeTable4Label2: '且交易額達<span>300萬</span><i>(或等值)</i>',
  cardThreeTable4Desc1: '滿足交易額條件後，發放7張代金券，即時生效可使用；',
  cardThreeTable4Desc2: '生效後60天內有效。',
  cardThreeTips: '註：首筆入金2萬獎勵和首筆入金30萬獎勵只能參與一個。',

  award: '獎',
  moneyCoupon: '代金券',
  awardTotal: '共獲得',
  cashCoupons: '現金券',
  giftPack: '禮包',
  highestGift: '最高贈送'
}
